// extracted by mini-css-extract-plugin
export default {"noImagePlaceholder":"noImage_noImagePlaceholder__2wKYE"};